import { parseAsNativeArrayOf, parseAsString, useQueryState } from "nuqs";
import { useMemo, useCallback } from "react";

/** URL パラメータ名（reservation-calendar 側と共通の語彙・形式） */
const PARAM_NAME = "area";

// nuqs parser for area filter (?area=slug1&area=slug2)
const areaFilterParser = parseAsNativeArrayOf(parseAsString);

/**
 * エリアフィルタの状態管理とURL同期を行うカスタムフック
 *
 * - nuqs を使用して URL パラメータ（繰り返しキー）と状態を同期
 * - エリアの slug で管理
 */
export function useAreaFilter() {
  const [urlFilter, setUrlFilter] = useQueryState(PARAM_NAME, areaFilterParser);

  // URL の文字列配列を Set<string> に変換
  const areaFilter = useMemo(
    () => new Set(urlFilter.filter((param) => param.length > 0)),
    [urlFilter],
  );

  const toggleArea = useCallback(
    (slug: string) => {
      const next = new Set(areaFilter);
      if (next.has(slug)) next.delete(slug);
      else next.add(slug);
      void setUrlFilter(next.size > 0 ? [...next] : null);
    },
    [areaFilter, setUrlFilter],
  );

  // ポップアップ「決定」・セクション「クリア」用の一括適用。
  const applyAreaSlugs = useCallback(
    (slugs: string[]) => {
      void setUrlFilter(slugs.length > 0 ? slugs : null);
    },
    [setUrlFilter],
  );

  return {
    /** 現在のエリアフィルタ状態（slug の Set） */
    areaFilter,
    /** エリアの選択状態をトグルし、URL に同期する */
    toggleArea,
    /** エリア選択を一括で適用する（ポップアップ決定・クリア用） */
    applyAreaSlugs,
  };
}
